import { T }     from 'defa-object';
import Slideable from 'scripts/plugins/slideable';
import template  from 'templates/notificationView.jst.html'
/**
 * defa.views.Notification
 * A description.
 * @version 0.1
 */
import View      from 'scripts/poppet/view';
const selectors = {
	markRead           : '[data-click=click-read]',
	deleteNotification : '[data-click=click-delete]',
};
const NotificationView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	

	slidable  : false,
	template  : template,
	className : 'unit-notification',
	attributes: {
		'data-element': 'slider',
	},
	
	ui: {
		read  : selectors.markRead,
		delete: selectors.deleteNotification,
	},

	events: {
		'click    @ui.read': 'onClickRead',
		'click    @ui.delete': 'onClickDelete',

	},
	
	templateContext: function () {
		return {
			datetime : this.getDateTime(),
			type     : this.getType(),
			readid   : 'read' + this.cid,
			deleteId : 'delete' + this.cid,
			read     : !this.model.get('read'),
		};
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// !TODO: Should I move all this elementSlid functionality into the NotificationCollectionView, as that is the
	// class that actually handles the listening?
	
	/**
	 * Triggers after the element is placed in the DOM.
	 * @void
	 */
	onDomRefresh: function () {
		// make this element a slideable
		let self = this;
		this.ui.read.prop('checked', this.model.get('read'));

		if(this.slideable) {
			self.$el.on( 'slid', function () {
				self.onElementSlid(); // placed in it's own closure to keep this;
			} );
			new Slideable( self.$el );
		}
	},
	
	/**
	 * Deletes the model form both view and server.
	 * Triggers when clicking the delete button
	 * !TODO: Improve the delete confirmation method and add translation
	 * @void
	 */
	onClickDelete: function(){
		this.trigger('delete', this);
	},
	
	/**
	 * Trigger when clicking the read checkbox
	 * @void
	 * Triggers read which is picked up by the Parentview(collection view)
	 * with the method onChildviewRead()
	 */
	onClickRead: function(){
		this.trigger('read', this, this.ui.read.prop('checked'));
	},
	
	/**
	 * Triggers when the element has slid off the screen.
	 * @void
	 * Triggers slid which is picked up by the Parentview(collection view)
	 * with the method onChildviewSlid()
	 */
	onElementSlid: function () {
		this.trigger( 'slid', this );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the DateTime in a proper human readable format.
	 * @void
	 */
	getDateTime: function () {
		let date = new Date( this.model.get( 'createdDate' ) );
		return date.format( T.dateFormatLong );
	},
	
	/**
	 * Gets the type of notification for the icon.
	 * @string
	 */
	getType: function( ){
		return ( this.model.get( 'emergencyLevel' ) )
			? 'icon-error'
			: 'icon-warning';
	},
	
} );

export default NotificationView;